import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import './globalStyles.css';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom"; 
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { DarkModeProvider } from './context/DarkModeContext';
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <DarkModeProvider>
        <App />
      </DarkModeProvider>
    </BrowserRouter>
  </React.StrictMode>
);


reportWebVitals();


